import { InputElement } from "./styled-components";

export default (inputDataInit) => InputElement(inputDataInit);
